module.exports = __webpack_public_path__ + "static/img/9.73e60ee.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/4/1/sp/9.png
// module id = /U7g
// module chunks = 0